import { adminPaymentChannelFormValues } from "@/schemas/payment-channels";
import {
  createData,
  deleteData,
  fetchData,
  updateData,
} from "@/services/api-service";

interface PaymentChannelKey {
  additionalProp1: string;
  additionalProp2: string;
  additionalProp3: string;
}

export type MerchantPaymentChannel = {
  paymentChannelId: number;
  name: string;
  description: string;
  key: PaymentChannelKey;
  active: boolean;
};

export type AdminPaymentChannel = {
  active: boolean;
  createdAt: string;
  createdBy: string;
  deletedAt: string;
  description: string;
  icon: string;
  id: number;
  keyCheck: string[];
  merchantBannedPaymentChannelList: any[];
  merchantPaymentChannelList: any[];
  name: string;
  updatedAt: string;
  updatedBy: string;
  version: number;
};

export const PAYMENT_CHANNEL_ENDPOINT = "/admin/payment-channel";

export type AdminPaymentChannelDto = {
  nonce: string;
  payload: adminPaymentChannelFormValues;
};

export const adminPaymentChannelApi = {
  // Get a single payment channel by ID
  getById: (id: number) =>
    fetchData<AdminPaymentChannel>(`${PAYMENT_CHANNEL_ENDPOINT}/${id}`),

  // Create a new payment channel
  create: (data: AdminPaymentChannelDto) =>
    createData<AdminPaymentChannel>(PAYMENT_CHANNEL_ENDPOINT, data),

  // Update an existing payment channel
  update: (id: number, data: AdminPaymentChannelDto) =>
    updateData<AdminPaymentChannel>(`${PAYMENT_CHANNEL_ENDPOINT}`, id, data),

  // Delete a payment channel
  delete: (id: number) => deleteData(PAYMENT_CHANNEL_ENDPOINT, id),

  // Toggle payment channel active status
  toggleActive: (id: number, active: boolean) =>
    updateData<AdminPaymentChannel>(`${PAYMENT_CHANNEL_ENDPOINT}`, id, {
      active,
    }),
};
